<template>
  <div class="sig-overlay">
    <!-- Aviso portrait: visível apenas quando dispositivo está na vertical -->
    <div class="sig-portrait-warning">
      <div class="sig-rotate-icon">⟳</div>
      <p>Vire o dispositivo na horizontal para assinar</p>
    </div>

    <!-- Conteúdo principal: visível apenas em landscape -->
    <div class="sig-landscape-content">
      <div class="sig-header">
        <span class="sig-title">{{ titulo }}</span>
        <div class="sig-actions">
          <button class="sig-btn sig-btn-clear" @click="limpar">Limpar</button>
          <button class="sig-btn sig-btn-confirm" @click="confirmar">Confirmar</button>
          <button class="sig-btn sig-btn-cancel" @click="$emit('cancelar')">Cancelar</button>
        </div>
      </div>
      <div class="sig-canvas-wrapper">
        <canvas ref="canvas" class="sig-canvas"></canvas>
        <div class="sig-guide-line">
          <span class="sig-guide-text">← Assine acima desta linha →</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad';

export default {
  name: 'SignaturePadModal',
  props: {
    titulo: { type: String, default: 'Assinatura' },
  },
  data() {
    return { pad: null };
  },
  mounted() {
    if (screen.orientation && screen.orientation.lock) {
      screen.orientation.lock('landscape').catch(() => {});
    }
    this.$nextTick(() => {
      this.pad = new SignaturePad(this.$refs.canvas, {
        backgroundColor: 'rgb(255,255,255)',
        penColor: 'rgb(0,0,0)',
      });
      this.ajustarCanvas();
      window.addEventListener('resize', this.ajustarCanvas);
    });
  },
  // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
  beforeDestroy() {
    if (screen.orientation && screen.orientation.unlock) {
      screen.orientation.unlock();
    }
    window.removeEventListener('resize', this.ajustarCanvas);
    if (this.pad) this.pad.off();
  },
  methods: {
    ajustarCanvas() {
      const canvas = this.$refs.canvas;
      if (!canvas) return;
      const data = this.pad ? this.pad.toData() : [];
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
      this.pad.clear();
      if (data.length) this.pad.fromData(data);
    },
    limpar() {
      this.pad.clear();
    },
    confirmar() {
      if (this.pad.isEmpty()) {
        alert('Por favor, realize a assinatura antes de confirmar.');
        return;
      }
      this.$emit('confirmada', this.pad.toDataURL('image/png'));
    },
  },
};
</script>

<style scoped>
.sig-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: #fff;
  z-index: 9999;
}

/* ── Aviso de portrait ── */
.sig-portrait-warning {
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #2c3e50;
  text-align: center;
  padding: 24px;
}
.sig-rotate-icon {
  font-size: 64px;
  margin-bottom: 16px;
  animation: girar 2s linear infinite;
}
@keyframes girar {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
.sig-portrait-warning p {
  font-size: 18px;
  font-weight: bold;
}

/* ── Conteúdo landscape ── */
.sig-landscape-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Em portrait: mostra aviso, esconde canvas */
@media (orientation: portrait) {
  .sig-portrait-warning  { display: flex; }
  .sig-landscape-content { display: none; }
}

/* Em landscape: esconde aviso, mostra canvas */
@media (orientation: landscape) {
  .sig-portrait-warning  { display: none; }
  .sig-landscape-content { display: flex; }
}

.sig-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: #2c3e50;
  color: #fff;
}
.sig-title {
  font-size: 16px;
  font-weight: bold;
}
.sig-actions {
  display: flex;
  gap: 8px;
}
.sig-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  font-weight: bold;
}
.sig-btn-clear    { background: #e74c3c; color: #fff; }
.sig-btn-confirm  { background: #27ae60; color: #fff; }
.sig-btn-cancel   { background: #95a5a6; color: #fff; }
.sig-canvas-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  background: #f5f5f5;
}
.sig-canvas {
  flex: 1;
  width: 100%;
  background: #fff;
  border: 2px solid #bdc3c7;
  border-radius: 4px;
  touch-action: none;
}
.sig-guide-line {
  margin-top: 6px;
  text-align: center;
  border-top: 2px dashed #e74c3c;
  padding-top: 4px;
}
.sig-guide-text {
  font-size: 12px;
  color: #e74c3c;
}
</style>
